import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Navigation } from '../components/Navigation/Navigation';
import { useAuth } from '../hooks/auths/useAuthService';
import { appRoutes } from '../config/appRoutes';
import { isCloud } from '../utils/urlUtils';
import { PageLoader } from '@diana/core';
import { FilterOptionsInitializer } from '../components/FilterOptionsInitializer';
import { useFilterOptionsData } from '../hooks/useFilterOptionsData';
import { Setup } from './Setup';
import { StreamErrorBanner } from '../components/StreamErrorBanner/StreamErrorBanner';

const loginType = isCloud() ? 'cloud' : 'edge';
const loginPath = `/login/${loginType}`;

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  const { hasData } = useFilterOptionsData();
  const location = useLocation();

  if (isAuthenticated() !== null && !isAuthenticated()) {
    const currentPath = location.pathname + location.search;
    return (
      <Navigate
        to={`${loginPath}?redirect_to=${encodeURIComponent(currentPath)}`}
        replace
      />
    );
  }

  return (
    <>
      <Setup />
      <FilterOptionsInitializer />
      <header className="app-header">
        <Navigation appRoutes={appRoutes} />
      </header>
      <StreamErrorBanner />
      <main className="app-content">
        {!hasData ? <PageLoader isLoading={true} /> : <Outlet />}
      </main>
    </>
  );
};

export default ProtectedRoute;
